export function buildUrl(base: string, path: string): string {
  if (!base) {
    return path;
  }

  const trimmedBase = base.replace(/\/+$/, '');
  const trimmedPath = path.replace(/^\/+/, '');

  return `${trimmedBase}/${trimmedPath}`;
}

export function assetUrl(
  storageBase: string,
  path: string | null | undefined
): string | null {
  if (path === null || path === undefined || path.length === 0) {
    return null;
  }

  if (/^https?:\/\//.test(path)) {
    return path;
  }

  return buildUrl(storageBase, path);
}
